const checkEmptyValueObject = (obj) => {
  return !Object.values(obj).some((value) => !!value);
};

export default checkEmptyValueObject;
